import type { ButtonProps } from "@/v2-backoffice-client/components/button"
import Button from "@/v2-backoffice-client/components/button"
import { useTranslationPendingRevert } from "@/v2-backoffice-client/translation/pending/translation.pending.revert"
import type { PendingChangeRow } from "@/v2-backoffice-client/translation/pending/translation.pending.utils"

const ADDED_TITLE =
  "Undo this addition: delete the translation row so it does not ship (the edit history is kept)."
const CHANGED_TITLE =
  "Write the previously published text back so this change does not ship."

export type TranslationPendingRevertButtonProps = Omit<
  ButtonProps,
  "onClick"
> & {
  row: PendingChangeRow
  onReverted?(): void
}

// Reverts one changelog line. Lives in the table's action cell, where a click
// must not also select/expand the row.
function TranslationPendingRevertButton(
  props: TranslationPendingRevertButtonProps,
) {
  const { row, onReverted, children, ...buttonProps } = props

  const { revertRows, loading } = useTranslationPendingRevert({ onReverted })

  return (
    <Button
      size="tiny"
      variant="secondary"
      data-feature-code="UI_BackofficeTranslation_Pending_Revert"
      isLoading={loading}
      disabled={loading}
      title={row.kind === "added" ? ADDED_TITLE : CHANGED_TITLE}
      onClick={(event) => {
        event.stopPropagation()
        void revertRows([row])
      }}
      {...buttonProps}
    >
      {children ?? "Revert"}
    </Button>
  )
}

export default TranslationPendingRevertButton
